import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';

const TABS = [
  { path: '/mobile/dashboard',   icon: '📊', label: '대시보드' },
  { path: '/mobile/turn-status', icon: '📋', label: '차수별' },
  { path: '/mobile/stock-chart', icon: '📈', label: '시세그래프' },
  { path: '/mobile/quick-trade', icon: '🔄', label: '매수매도' },
  { path: '/mobile/balance',     icon: '💰', label: '잔고확인' },
];

export default function BottomTabBar() {
  const navigate  = useNavigate();
  const { pathname } = useLocation();

  return (
    <nav className="mb-bottom-tabs">
      {TABS.map(t => (
        <button
          key={t.path}
          className={`mb-tab-btn${pathname.startsWith(t.path) ? ' active' : ''}`}
          onClick={() => navigate(t.path)}
        >
          <span className="mb-tab-icon">{t.icon}</span>
          <span className="mb-tab-label">{t.label}</span>
        </button>
      ))}
    </nav>
  );
}
